export const productName = 'GEOTHERMAL ENERGY TEACHER READY';
export const productShortName = 'Geothermal Energy Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/1FmMqYf8yNr8cjNDLVXFXy/MOCKUP_1.56.29_p._m..png';

export const checkoutUrl = 'https://geothermal-energy.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Geothermal Energy Fundamentals',
  'Volume 2 — Geothermal Geology, Resources & Exploration',
  'Volume 3 — Geothermal Drilling & Well Engineering',
  'Volume 4 — Geothermal Power Generation Technologies',
  'Volume 5 — Geothermal Heating & Direct-Use Applications',
  'Volume 6 — Environmental Impacts, Safety & Sustainability',
  'Volume 7 — Geothermal Energy Economics & Global Markets',
  'Volume 8 — Advanced Geothermal Technologies, Innovation & Future Developments',
  'Volume 9 — Teaching Geothermal Energy',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Geothermal Energy Teacher Assessment Kit',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Geothermal Energy Teacher Dictionary: 200 Essential Concepts',
  'Bonus 5 — Geothermal Energy Teacher Lesson Planning Guide (10 Detailed Lesson Plans + 15 Additional Lessons)',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex geothermal energy concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see geothermal energy's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
